<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
    @closed="dialogClose"
    width="60%"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    element-loading-text="加载中..."
  >
    <div></div>
    <template v-if="title == '健身课程'">
      <VueWeekPicker @dateValue="initData" :dateValue="signUpData.StartTime" />
      <div class="d2-clearfix"></div>
      <el-card class="d2-mb-10 d2-mt-20" :body-style="{ padding: '5px 15px' }">
        <div v-for="(item, index) in groupData" :key="index">
          <template v-if="item.detailTable.length == 0">
            <el-empty description="暂无活动信息" />
          </template>
          <el-row
            v-else
            :gutter="15"
            class="signup_row d2-mt-10"
            v-for="(unit, i) in item.detailTable"
            :key="i"
          >
            <el-col :span="3" class="d2-text-center">
              <div class="signup_icon">
                <img src="~@/assets/img/wxyd.png" width="40" height="40" />
              </div>
            </el-col>
            <el-col :span="18">
              <el-descriptions :column="1">
                <el-descriptions-item label="项目">
                  {{ unit.LineName }}
                </el-descriptions-item>
                <el-descriptions-item label="地点">
                  {{ unit.PlaceName }}
                </el-descriptions-item>
                <el-descriptions-item label="时间">
                  {{ unit.CourseTime }}
                </el-descriptions-item>
                <el-descriptions-item label="总名额">
                  {{ unit.MaxLimit > 100000 ? "无限制" : unit.MaxLimit }}
                </el-descriptions-item>
                <el-descriptions-item label="剩余名额">
                  {{
                    unit.RestSignUpCount > 100000
                      ? "无限制"
                      : unit.RestSignUpCount
                  }}
                </el-descriptions-item>
                <el-descriptions-item
                  label="候补人数上限"
                  v-if="unit.HouBuStatus"
                >
                  {{ unit.HouBuLimit }}
                </el-descriptions-item>
                <el-descriptions-item
                  label="现有候补人数"
                  v-if="unit.HouBuStatus"
                >
                  {{ unit.HouBuCount }}
                </el-descriptions-item>
              </el-descriptions>
            </el-col>
            <el-col :span="3" class="d2-text-center">
              <div v-if="unit.SignStatus == '报名中'">
                <el-button
                  type="primary"
                  round
                  size="small"
                  @click="reservationHandle(unit, i)"
                  >预约
                </el-button>
              </div>
              <div v-else-if="unit.SignStatus == '已报名'">
                <el-button
                  type="primary"
                  round
                  size="small"
                  @click="cancleHandle(unit, i)"
                  >取消预约
                </el-button>
              </div>
              <div v-else-if="unit.SignStatus == '候补中'">
                <el-button
                  type="primary"
                  round
                  size="small"
                  @click="cancleHandle(unit, i)"
                  >取消候补
                </el-button>
              </div>
              <div v-else>
                <el-button type="info" round size="small">{{
                  unit.SignStatus
                }}</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </template>

    <template v-else-if="title == '专项礼品'">
      <el-steps
        :active="active"
        finish-status="success"
        simple
        class="d2-mb-10"
        v-if="!isApply"
      >
        <el-step title="选择礼品" icon="el-icon-edit"></el-step>
        <el-step title="完成提交" icon="el-icon-s-claim"></el-step>
      </el-steps>
      <template v-if="active == 0">
        <template v-for="(val, key, i) in moneyData">
          <el-card
            class="d2-mb-10"
            :body-style="{ padding: '5px 15px 15px 15px' }"
            :key="key + i"
          >
            <div slot="header" class="clearfix">
              <span
                >礼品清单<el-tag class="d2-ml-10" type="warning" size="mini">
                  (最多选择{{ numLimit[key].MaxLimit }}项，最少选择{{
                    numLimit[key].MinLimit
                  }}项)</el-tag
                ></span
              >
            </div>
            <el-form>
              <el-checkbox-group v-model="checkList" :max="mainData.MaxLimit">
                <el-row :gutter="15" class="sign_row">
                  <el-col
                    :span="12"
                    class="d2-mt-10 sign_checkbox"
                    v-for="(unit, num, i) in val"
                    :key="i"
                  >
                    <el-checkbox
                      class="sign_checkbox"
                      :label="unit.dataCode"
                      @change="
                        (value) => {
                          checkSign(value, unit,priceData[key]);
                        }
                      "
                    >
                      <img
                        :src="unit.otherData.DesImage"
                        style="
                          width: 120px;
                          height: 80px;
                          border-radius: 5px;
                          margin-right: 10px;
                        "
                      />
                    </el-checkbox>
                    <el-descriptions :column="1">
                      <template slot="title">
                        {{ unit.name }}
                      </template>
                      <template v-if="unit.otherData.RestSignUpCount > 0">
                        <el-descriptions-item label="数量">
                          <el-input-number
                            :disabled="!unit.ischeck"
                            size="mini"
                            v-model="unit.apply"
                            :min="1"
                            :max="unit.otherData.ChoiceCount"
                            @change="
                              (value) => {
                                handleChange(value, unit,priceData[key]);
                              }
                            "
                          >
                          </el-input-number>
                          <el-tag class="d2-ml-10" type="warning" size="mini">
                            最多选择{{
                              unit.otherData.SignUpLimit == -1
                                ? "无限制"
                                : unit.otherData.SignUpLimit + "个"
                            }}
                          </el-tag>
                        </el-descriptions-item>
                        <el-descriptions-item label="剩余库存">
                          {{
                            unit.otherData.RestSignUpCount > 100000
                              ? "无上限"
                              : unit.otherData.RestSignUpCount
                          }}
                          <el-tag
                            class="d2-ml-10"
                            type="warning"
                            size="mini"
                            v-if="unit.otherData.RestSignUpCount <= 0"
                          >
                            库存不足
                          </el-tag>
                        </el-descriptions-item>
                      </template>
                    </el-descriptions>
                  </el-col>
                </el-row>
              </el-checkbox-group>
            </el-form>
          </el-card>
        </template>
      </template>
      <template v-if="active == 1">
        <el-card class="d2-mb-10" :body-style="{ padding: '5px 15px' }">
          <div slot="header" class="clearfix">
            <span>员工信息</span>
          </div>
          <el-descriptions title="" style="margin-top:10px;">
            <el-descriptions-item label="AD账号">{{unitname.uInfo.AdAccount}}</el-descriptions-item>
            <el-descriptions-item label="姓名">{{unitname.uInfo.Name}}</el-descriptions-item>
            <el-descriptions-item label="城市">{{unitname.uInfo.City}}</el-descriptions-item>

            <el-descriptions-item label="电话">{{unitname.uInfo.Mobile}}</el-descriptions-item>
            <el-descriptions-item label="部门">{{unitname.uInfo.Depart}}</el-descriptions-item>
            <el-descriptions-item label="分站">{{unitname.uInfo.Substation}}</el-descriptions-item>

            <el-descriptions-item label="小组">{{unitname.uInfo.GroupName}}</el-descriptions-item>
            <el-descriptions-item label="邮件">{{unitname.uInfo.Email}}</el-descriptions-item>
            
        </el-descriptions>
        </el-card>
        <el-card class="d2-mb-10" :body-style="{ padding: '5px 15px' }">
          <div v-if="shippingAddress.name" class="sign_address">
            <i class="el-icon-location-information"></i>
            <div>
              <p>
                {{ shippingAddress.name }}<span>{{ shippingAddress.tel }}</span>
              </p>
              <p>{{ shippingAddress.address }}</p>
            </div>
            <i class="el-icon-edit" @click="showAddress(shippingAddress)"></i>
          </div>
          <div v-else class="sign_address">
            <i class="el-icon-location-information"></i>
            <div>
              <p>收货地址</p>
            </div>
            <i class="el-icon-edit" @click="showAddress({})"></i>
          </div>
        </el-card>
        <el-card
          class="d2-mb-10"
          :body-style="{ padding: '5px 15px 15px 15px' }"
        >
          <div slot="header" class="clearfix">
            <span
              >礼品清单<el-tag
                class="d2-ml-10"
                type="warning"
                size="mini"
                v-if="isApply"
                >请耐心等待...</el-tag
              ></span
            >
          </div>
          <el-form>
            <el-row :gutter="15" class="sign_row">
              <el-col
                :span="12"
                class="d2-mt-10 sign_checkbox"
                v-for="(unit, i) in applyArray"
                :key="i"
              >
                <img
                  :src="unit.DesImage"
                  style="
                    width: 120px;
                    height: 80px;
                    border-radius: 5px;
                    margin-right: 10px;
                  "
                />
                <el-descriptions :column="1">
                  <template slot="title">
                    {{ unit.LineName }}
                  </template>
                  <el-descriptions-item label="数量">
                    {{ unit.SignCount }}
                  </el-descriptions-item>
                </el-descriptions>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </template>
      <div slot="footer" class="dialog-footer" v-if="isApply">
        <!-- 新需求取消取消预定 -->
        <!-- <el-button type="primary" @click="cancelReserve">取消预定</el-button> -->
      </div>
      <div slot="footer" class="dialog-footer" v-else>
        <div style="padding: 14px; border-top: 1px dashed #eee">
          <span
            >数量：<b class="d2-mr-5" style="color: #60b0ed">{{ allNum }}</b
            ></span
          >
        </div>
        <el-button v-if="active == 1" @click="prevStep">上一步</el-button>
        <el-button type="primary" @click="nextStep">提交预定</el-button>
      </div>
    </template>

    <template v-else-if="title == '旅游出行'">
      <el-steps
        :active="active"
        finish-status="success"
        simple
        class="d2-mb-10"
        v-if="
          !isApply && !(mainData.FamilyObject == 'on' && !unitname.uInfo.Job)
        "
      >
        <el-step title="选择项目" icon="el-icon-edit"></el-step>
        <el-step title="完成提交" icon="el-icon-s-claim"></el-step>
      </el-steps>
      <template v-if="active == 0">
        <p v-if="HDFL=='新视野'">
          本年代金券金额：<b class="d2-mr-20" style="color: #60b0ed">{{
            Coupon.Money
          }}</b>
          已使用：<b class="d2-mr-20" style="color: #f13f3d">{{ useCoupon }}</b>
          剩余：<b class="d2-mr-20" style="color: #60b0ed">{{
            remainderCoupon
          }}</b>
          <el-tag class="d2-ml-10" type="warning" size="mini">
            必填(最多选择{{ mainData.MaxLimit }}项，最少选择{{
              mainData.MinLimit
            }}项)
          </el-tag>
        </p>
        <template v-for="(val, key, i) in moneyData">
          <el-card
            class="d2-mb-10"
            :body-style="{ padding: '5px 15px' }"
            :key="key + i"
          >
            <div slot="header" class="clearfix">
              <span>{{ key }}</span>
              <el-tag
                          class="d2-ml-10"
                          type="warning"
                          size="mini"
                        >
                          (最多选择{{ numLimit[key].MaxLimit }}项，最少选择{{
                            numLimit[key].MinLimit
                          }}项)</el-tag
                        >
            </div>
            <el-form>
              <el-checkbox-group v-model="checkList" :max="mainData.MaxLimit">
                <el-row :gutter="15" class="sign_row">
                  <el-col
                    :span="12"
                    class="d2-mt-10"
                    v-for="(unit, num, i) in val"
                    :key="i"
                  >
                    <el-checkbox
                      :label="unit.dataCode"
                      @change="
                        (value) => {
                          checkSign(value, unit,priceData[key]);
                        }
                      "
                    >
                      <el-descriptions :column="1">
                        <template slot="title">
                          {{ unit.name }}
                        </template>
                        <el-descriptions-item label="单人最多报名名额">
                          {{
                            unit.otherData.SignUpLimit == -1
                              ? "无限制"
                              : unit.otherData.SignUpLimit
                          }}
                        </el-descriptions-item>
                        <el-descriptions-item
                          :label="
                            title == '旅游出行' ? '剩余报名名额' : '剩余数量'
                          "
                        >
                          {{
                            unit.otherData.RestSignUpCount > 100000
                              ? "无限制"
                              : unit.otherData.RestSignUpCount
                          }}
                          <el-tag
                            class="d2-ml-10"
                            type="warning"
                            size="mini"
                            v-if="unit.otherData.UserCoupon && HDFL=='新视野'"
                          >
                            代金券最多使用比例：{{ unit.couponRate }}%</el-tag
                          >
                        </el-descriptions-item>
                        <el-descriptions-item
                          label="当前候补数量"
                          v-if="unit.otherData.HouBuStatus"
                        >
                          {{ unit.otherData.HouBuCount }}
                        </el-descriptions-item>
                      </el-descriptions>
                    </el-checkbox>
                    <el-descriptions :column="1" style="padding-left: 24px">
                      <template
                        v-if="
                          mainData.FamilyObject == 'on' && !unitname.uInfo.Job
                        "
                      >
                        <el-descriptions-item
                          label="人员选择"
                          labelStyle="min-width:60px"
                        >
                          <el-checkbox-group
                            v-model="moneyData[key][num].family"
                            :disabled="!unit.ischeck"
                          >
                            <el-row :gutter="15" class="sign_row">
                              <el-col
                                :span="24"
                                v-for="(obj, index) in family"
                                :key="index"
                              >
                                <el-checkbox
                                  :label="obj.CardNumber"
                                  :disabled="obj.CardNumber ? false : true"
                                  @change="
                                    (value) => {
                                      checkRenSign(
                                        value,
                                        priceData[key],
                                        unit
                                      );
                                    }
                                  "
                                >
                                  {{ obj.Name }}（{{
                                    obj.CardNumber
                                      ? judgeCard(obj.CardNumber)
                                      : "信息不全"
                                  }}）
                                </el-checkbox>
                              </el-col>
                            </el-row>
                          </el-checkbox-group>
                        </el-descriptions-item>
                      </template>
                      <template v-else>
                        <el-descriptions-item label="报名人数">
                          <el-input-number
                            :disabled="!unit.ischeck"
                            size="mini"
                            v-model="unit.apply"
                            :min="1"
                            :max="unit.otherData.ChoiceCount"
                            @change="
                              (value) => {
                                handleChange(value, unit,priceData[key]);
                              }
                            "
                          >
                          </el-input-number>
                        </el-descriptions-item>
                      </template>
                      <el-descriptions-item
                        label="代金券金额"
                        labelStyle="min-width:81px"
                        v-if="unit.otherData.UserCoupon && HDFL=='新视野'"
                      >
                        <el-input-number
                          :disabled="!unit.ischeck"
                          size="mini"
                          v-model="unit.Coupon"
                          :min="0"
                          :max="checkMax(unit,key,priceData[key])"
			                    @keydown.native="channelInputLimit"
                          @change="
                            (value) => {
                              handleChangeDai(value, unit);
                            }
                          "
                          :step="
                            remainderCoupon && remainderCoupon <= 9 ? 1 : 10
                          "
                          step-strictly
                        >
                        </el-input-number>
                        <el-tag type="warning" class="d2-ml-10" size="mini" v-if="HDFL=='新视野'">
                          价格：{{ unit.price * unit.apply }}，现金金额：{{
                            unit.price * unit.apply - unit.Coupon
                          }}</el-tag
                        >
                      </el-descriptions-item>
                    </el-descriptions>
                  </el-col>
                </el-row>
              </el-checkbox-group>
            </el-form>
            <div style="padding: 14px" v-if="HDFL=='新视野'">
              <span
                >总金额：<b class="d2-mr-20" style="color: #60b0ed">{{
                  priceData[key].allPrice
                }}</b
                >现金：<b class="d2-mr-20" style="color: #f13f3d">{{
                  priceData[key].cash
                }}</b
                >代金券：<b class="d2-mr-20" style="color: #60b0ed">{{
                  priceData[key].coupon
                }}</b></span
              >
            </div>
          </el-card>
        </template>
      </template>
      <template v-if="active == 1">
        <el-card class="d2-mb-10" :body-style="{ padding: '0' }">
          <div slot="header" class="clearfix">
            <!-- <span></span> -->
            <el-form
              ref="partner"
              :inline="true"
              label-width="70px"
              size="mini"
            >
              <el-form-item label="住宿搭档" style="margin-bottom: 0">
                <el-select
                  v-model.trim="partnerText"
                  placeholder="请选择住宿搭档"
                  clearable
                  @change="
                    (val) => {
                      partnerChange(val, partnerOption);
                    }
                  "
                >
                  <el-option
                    v-for="val in partnerOption"
                    :label="val.Name"
                    :value="val.Code"
                    :key="val.Code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
        <el-card
          class="d2-mb-10"
          :body-style="{ padding: '5px 15px 15px 15px' }"
        >
          <div slot="header" class="clearfix">
            <span>参与人员信息</span>
          </div>
          <el-card
            class="d2-mb-10"
            :body-style="{ padding: '5px 15px 15px 15px' }"
            v-for="(obj, index) in step2PeopleInfo"
            :key="index"
          >
            <h3>{{ obj.showName }}</h3>
            <el-form
              class="d2-mr-10 d2-mt-5"
              ref="step2PeopleInfo"
              :model="obj"
              label-width="80px"
            >
              <el-form-item
                label="姓名"
                prop="Name"
                :rules="[
                  { required: true, message: '不能为空', trigger: 'blur' },
                ]"
              >
                <el-input v-model="obj.Name"></el-input>
              </el-form-item>
              <el-form-item
                label="联系方式"
                prop="Mobile"
                :rules="[
                  {
                    required: true,
                    pattern: /^1[345789]\d{9}$/,
                    message: '请输入正确的手机号码',
                    trigger: ['blur', 'change'],
                  },
                ]"
              >
                <el-input v-model="obj.Mobile"></el-input>
              </el-form-item>
              <el-form-item
                label="证件号码"
                prop="CardNumber"
                :rules="[
                  {
                    required: true,
                    pattern: /^[0-9]*$/,
                    message: '不能为空',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input v-model="obj.CardNumber"></el-input>
              </el-form-item>
            </el-form>
          </el-card>
        </el-card>
      </template>
      <div slot="footer" class="dialog-footer">
        <div
          style="padding: 14px; border-top: 1px dashed #eee"
          v-if="active == 0" 
        >
          <span v-if="HDFL=='新视野'"
            >数量：<b class="d2-mr-5" style="color: #60b0ed">{{ allNum }}</b
            > 现金：<b class="d2-mr-5" style="color: #f13f3d"
              >￥{{ useMoney }}</b
            >代金券：<b class="d2-mr-5" style="color: #60b0ed"
              >￥{{ useCoupon }}</b
            ></span
          >
        </div>
        <div v-if="mainData.FamilyObject == 'on' && !unitname.uInfo.Job">
          <el-button type="primary" @click="submitHandle">提交报名</el-button>
        </div>
        <div v-else>
          <el-button v-if="active == 1" @click="prevStep">上一步</el-button>
          <el-button type="primary" @click="nextStep">{{
            active == 0 ? "下一步" : "提交报名"
          }}</el-button>
          <el-button v-if="isApply" type="primary" @click="cancelReserve"
            >取消预定</el-button
          >
        </div>
      </div>
    </template>

    <template v-else>
      <p v-if="HDFL=='新视野'">
        本年代金券金额：<b class="d2-mr-20" style="color: #60b0ed">{{
          Coupon.Money
        }}</b>
        已使用：<b class="d2-mr-20" style="color: #f13f3d">{{ useCoupon }}</b>
        剩余：<b class="d2-mr-20" style="color: #60b0ed">{{
          remainderCoupon
        }}</b>
        <el-tag class="d2-ml-10" type="warning" size="mini"
          >必填(最多选择{{ mainData.MaxLimit }}项，最少选择{{
            mainData.MinLimit
          }}项)
        </el-tag>
      </p>
      <template v-for="(val, key, i) in moneyData">
        <el-card
          class="d2-mb-10"
          :body-style="{ padding: '5px 15px' }"
          :key="key + i"
          v-if="
            numLimit[key].Sex && title == '联谊活动'
              ? unitname.uInfo.Sex == numLimit[key].Sex
              : true
          "
        >
          <div slot="header" class="clearfix">
            <span>{{ key }}</span>
            <el-tag
                          class="d2-ml-10"
                          type="warning"
                          size="mini"
                          v-show="
                            title == '旅游出行' ||
                            title == '兴趣俱乐部活动' ||
                            title == '联谊活动'
                          "
                        >
                          (最多选择{{ numLimit[key].MaxLimit }}项，最少选择{{
                            numLimit[key].MinLimit
                          }}项)</el-tag
                        >
          </div>
          <el-form>
            <el-checkbox-group v-model="checkList" :max="mainData.MaxLimit">
              <el-row :gutter="15" class="sign_row">
                <el-col
                  :span="12"
                  class="d2-mt-10"
                  v-for="(unit, num, i) in val"
                  :key="i"
                >
                  <el-checkbox
                    :label="unit.dataCode"
                    @change="
                      (value) => {
                        checkSign(value, unit,priceData[key]);
                      }
                    "
                  >
                    <el-descriptions :column="1">
                      <template slot="title">
                        {{ unit.name }}
                      </template>

                      <template v-if="title == '兴趣俱乐部活动'">
                        <el-descriptions-item label="人数上限">
                          {{
                            unit.otherData.MaxLimit > 100000
                              ? "无限制"
                              : unit.otherData.MaxLimit
                          }}
                        </el-descriptions-item>
                        <el-descriptions-item label="剩余名额">
                          {{
                            unit.otherData.RestSignUpCount > 100000
                              ? "无限制"
                              : unit.otherData.RestSignUpCount
                          }}
                        </el-descriptions-item>
                        <el-descriptions-item
                          label="当前候补数量"
                          v-if="unit.otherData.HouBuStatus"
                        >
                          {{ unit.otherData.HouBuCount
                          }}<el-tag
                            class="d2-ml-10"
                            type="warning"
                            size="mini"
                            v-if="unit.otherData.UserCoupon && HDFL=='新视野'"
                          >
                            代金券最多使用比例：{{ unit.couponRate }}%</el-tag
                          >
                        </el-descriptions-item>
                      </template>

                      <template v-else-if="title == '联谊活动'">
                        <el-descriptions-item label="报名人数上限">
                          {{
                            unit.otherData.MaxLimit > 100000
                              ? "无限制"
                              : unit.otherData.MaxLimit
                          }}
                        </el-descriptions-item>
                        <el-descriptions-item label="剩余名额">
                          {{
                            unit.otherData.RestSignUpCount > 100000
                              ? "无限制"
                              : unit.otherData.RestSignUpCount
                          }}
                        </el-descriptions-item>
                        <el-descriptions-item label="已报名男性">
                          {{ man }}
                        </el-descriptions-item>
                        <el-descriptions-item label="已报名女性">
                          {{ woman }}
                        </el-descriptions-item>
                        <el-descriptions-item
                          label="当前候补男性"
                          v-if="unit.otherData.HouBuStatus"
                        >
                          {{ unit.otherData.HouBuMCount }}
                        </el-descriptions-item>
                        <el-descriptions-item
                          label="当前候补女性"
                          v-if="unit.otherData.HouBuStatus"
                        >
                          {{ unit.otherData.HouBuFCount
                          }}<el-tag
                            class="d2-ml-10"
                            type="warning"
                            size="mini"
                            v-if="unit.otherData.UserCoupon && HDFL=='新视野'"
                          >
                            代金券最多使用比例：{{ unit.couponRate }}%</el-tag
                          >
                        </el-descriptions-item>
                      </template>
                      <!-- 票务活动 通用活动-禁用代金券  通用活动-启用代金券 旅游出行-->
                      <template v-else>
                        <el-descriptions-item label="单人最多报名名额">
                          {{
                            unit.otherData.SignUpLimit == -1
                              ? "无限制"
                              : unit.otherData.SignUpLimit
                          }}
                        </el-descriptions-item>
                        <el-descriptions-item
                          :label="
                            title == '旅游出行' ? '剩余报名名额' : '剩余数量'
                          "
                        >
                          {{
                            unit.otherData.RestSignUpCount > 100000
                              ? "无限制"
                              : unit.otherData.RestSignUpCount
                          }}
                          <el-tag
                            class="d2-ml-10"
                            type="warning"
                            size="mini"
                            v-if="HDFL=='新视野' && unit.otherData.UserCoupon"
                          >
                            代金券最多使用比例：{{ unit.couponRate }}%</el-tag
                          >
                        </el-descriptions-item>
                        <el-descriptions-item
                          label="当前候补数量"
                          v-if="unit.otherData.HouBuStatus"
                        >
                          {{ unit.otherData.HouBuCount }}
                        </el-descriptions-item>
                      </template>
                    </el-descriptions>
                  </el-checkbox>
                  <el-descriptions :column="1" style="padding-left: 24px">
                    <template v-if="title == '兴趣俱乐部活动'">
                      <el-descriptions-item label="预订票数">
                        <el-input-number
                          :disabled="!unit.ischeck"
                          size="mini"
                          v-model="unit.apply"
                          :min="1"
                          :max="unit.otherData.ChoiceCount"
                          @change="
                            (value) => {
                              handleChange(value, unit,priceData[key]);
                            }
                          "
                        >
                        </el-input-number>
                      </el-descriptions-item>
                    </template>
                    <template v-else-if="title == '联谊活动'"></template>
                    <template v-else-if="title == '票务活动'">
                      <el-descriptions-item label="预订票数">
                        <el-input-number
                          :disabled="!unit.ischeck"
                          size="mini"
                          v-model="unit.apply"
                          :min="1"
                          :max="unit.otherData.ChoiceCount"
                          @change="
                            (value) => {
                              handleChange(value, unit,priceData[key]);
                            }
                          "
                        >
                        </el-input-number>
                      </el-descriptions-item>
                    </template>
                    <!-- 通用活动-禁用代金券  通用活动-启用代金券-->
                    <template v-else>
                      <el-descriptions-item label="报名数量">
                        <el-input-number
                          :disabled="!unit.ischeck"
                          size="mini"
                          v-model="unit.apply" 
                          :min="1"
                          :max="unit.otherData.ChoiceCount"
                          @change="
                            (value) => {
                              handleChange(value, unit,priceData[key]);
                            }
                          "
                        >
                        </el-input-number>
                      </el-descriptions-item>
                    </template>
                    
                    <el-descriptions-item
                      label="代金券金额"
                      v-if="unit.otherData.UserCoupon && HDFL=='新视野'"
                    >
                      <el-input-number
                        :disabled="!unit.ischeck"
                        size="mini"
                        v-model="unit.Coupon"
                        @keydown.native="channelInputLimit"
                        :min="0"
                        :max="checkMax(unit,key,priceData[key])"
                        @change="
                          (value) => {
                            handleChangeDai(value, unit);
                          }
                        "
                        :step="remainderCoupon && remainderCoupon <= 9 ? 1 : 10"
                        step-strictly
                      >
                      </el-input-number>
                      <el-tag type="warning" class="d2-ml-10" size="mini" v-if="HDFL=='新视野'">
                        价格：{{ unit.price * unit.apply }}，现金金额：{{
                          unit.price * unit.apply - unit.Coupon
                        }}</el-tag
                      >
                    </el-descriptions-item>
                  </el-descriptions>
                </el-col>
              </el-row>
            </el-checkbox-group>
          </el-form>
          <div
            style="padding: 14px"
            v-if="
              title == '兴趣俱乐部活动' ||
              title == '联谊活动' ||
              title == '票务活动' ||
              title == '通用活动-启用代金券'
            "
          >
            <span v-if="HDFL=='新视野'"
              >总金额：<b class="d2-mr-20" style="color: #60b0ed">{{
                priceData[key].allPrice
              }}</b
              >现金：<b class="d2-mr-20" style="color: #f13f3d">{{
                priceData[key].cash
              }}</b
              >代金券：<b class="d2-mr-20" style="color: #60b0ed">{{
                priceData[key].coupon
              }}</b></span
            >
          </div>
        </el-card>
      </template>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitHandle">提交报名</el-button>
      </div>
    </template>
    <delivery-address
      v-model="addressShow"
      :address="address"
      @submit="setAddress"
    ></delivery-address>
  </el-dialog>
</template>
<script>
import * as indexService from "@/api/sys/index";
import VueWeekPicker from "@/components/vue-week-picker";
import deliveryAddress from "./deliveryAddress";
import dayjs from "dayjs";
export default {
  name: "signUp",
  components: {
    VueWeekPicker,
    deliveryAddress,
  },
  props: {
    signUpData: Object,
    HDFL:String,
    value: Boolean,
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      setting: false,
      title: "",
      //金额
      Coupon: {}, // 请求金额
      allPrice: 0, //总金额
      allCoupon: 0, //
      allNum: 0, //总数量
      useCoupon: 0, //已使用代金券
      useMoney: 0,
      remainderCoupon: 0, //剩余代金券
      //主
      mainData: {},
      step1Data: null,
      step2PeopleInfo: [],
      priceData: {}, //每个模块下的价格
      groupData: [],
      peopleInfo: [],
      family: [],
      partner: null,
      //选中 checkbox
      checkList: [],
      updataList: [],
      //重组
      moneyData: {},
      numLimit: {},
      //
      isApply: false,
      isChange: false,
      // 已报名
      signUpInfo: [],
      shippingAddress: {},
      // 提交
      applyArray: [],
      // 男女数量
      man: 0,
      woman: 0,

      // 当前所处步骤位置
      active: 0,
      // 地址弹框
      addressShow: false,
      address: {},

      partnerText: "", // 住宿搭档
      partnerOption: [], //住宿
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    },
    moneyData: {
      deep: true,
      handler: function (newV) {
        // console.log(newV);
        this.calculate();
      },
    },
  },
  computed: {
    unitname() {
      return this.$store.state.d2admin.userInfo.userinfo;
    },
  },
  methods: {
    channelInputLimit(e) {
      e.returnValue = "";
    },
    dialogOpen() {
      this.title = this.signUpData.ActivityParton;
      if (
        this.title == "旅游出行" ||
        this.title == "兴趣俱乐部活动" ||
        this.title == "票务活动" ||
        this.title == "联谊活动" ||
        this.title == "通用活动-禁用代金券" ||
        this.title == "通用活动-启用代金券"
      )
        this.setting = true;
      if (this.signUpData.ID) {
        this.MobileIndexGetUserCardValue(this.signUpData.ID);
        this.GetSignUpInfo(this.signUpData.ID);
      } else {
        this.dialogClose();
      }
    },
    //脱敏
    judgeCard(val) {
      if (!val) return "";
      let reg = /^(.{3}).*(.{2})$/;
      return val.replace(/(?<=\d{6})\d{12}/, "************");
    },
    // 获取详细信息
    GetActivityDetail(activityId, data = "") {
      this.loading = true;
      let prams = {
        activityId: activityId,
      };
      if (data) {
        prams = {
          ...prams,
          date: data,
        };
      } else {
        prams = {
          ...prams,
          isChange: this.isChange,
        };
      }
      indexService.GetActivityDetail(prams).then((data) => {
        this.groupData = [];
        this.moneyData = {};
        this.active = 0;
        this.mainData = data.data.mainData;
        this.peopleInfo = data.data.peopleInfo;
        let family = data.data.family;
        if (family) {
          var first = [];
          var other = [];
          for (let i = 0; i < family.length; i++) {
            if (family[i].Name == "本人") {
              first.push(family[i]);
            } else {
              other.push(family[i]);
            }
          }
          family = [...first, ...other];
        }
        this.family = family ? family : null;
        let partnerList = data.data.partnerList;
        if (partnerList && partnerList[0]) {
          this.partner = {
            CardNumber: partnerList[0].CardNumber,
            Name: partnerList[0].Name,
            Mobile: partnerList[0].Mobile,
          };
          this.partnerText = `${partnerList[0].Name}`;
        }

        this.groupData = data.data.groupData;
        // 数据重组
        let groupData = JSON.parse(JSON.stringify(data.data.groupData));
        // console.log(this.groupData,groupData);
        groupData.forEach((v) => {
          console.log(v);
          this.moneyData[v.mainTable.Name] = {};
          this.numLimit[v.mainTable.Name] = {};
          let allPrice = 0,
            cash = 0,
            coupon = 0;
          v.detailTable = v.detailTable.map((i) => {
            let data = {};
            if(!i.UserCoupon) i.CouponRate = 0;
            console.log('this.signUpInfo',this.signUpInfo);
            if (this.signUpInfo.length != 0) {
              //已报名
              var find = this.signUpInfo.find(
                (item) => item.DataCode == i.DataCode
              );
              if (find) {
                //有相关数据
                if (!this.moneyData[v.mainTable.Name][i.ID]) {
                  var familyArray = [];
                  if (find.Family) {
                    try {
                      let family = JSON.parse(find.Family);
                      for (let i = 0; i < family.length; i++) {
                        familyArray.push(family[i].CardNumber);
                      }
                    } catch (err) {}
                  }
                  data = {
                    Coupon: find.CouponAmount,
                    ID: i.ID,
                    apply: find.SignCount,
                    ischeck: true,
                    couponRate: i.CouponRate,
                    dataCode: i.DataCode,
                    name: i.LineName,
                    price: i.Price,
                    family: familyArray,
                    otherData: {
                      ...i,
                      groupName: v.mainTable.Name,
                    },
                  };
                  this.moneyData[v.mainTable.Name][i.ID] = data;
                  this.numLimit[v.mainTable.Name] = {
                    MaxLimit: Number(v.mainTable.MaxLimit),
                    MinLimit: Number(v.mainTable.MinLimit),
                    Sex: v.mainTable.Sex,
                  };
                  this.checkList.push(i.DataCode);
                  this.checkList.forEach((v) => {
                    if (v == i.DataCode) {
                      this.updataList.push(i.DataCode + "|" + find.SignCount);
                    }
                  });
                  // 专项礼品
                  if (this.title == "专项礼品") {
                    this.$nextTick(() => {
                      this.active = 1;
                      this.allNum += find.SignCount;
                      this.applyArray = [];
                      this.applyArray.push({
                        ActivityId: find.ActivityId,
                        ActivityName: find.ActivityName,
                        CashAmount: find.CashAmount,
                        CouponAmount: find.CouponAmount,
                        LineName: find.LineName,
                        PartnerList: this.partner ? this.partner : [],
                        SignCount: find.SignCount,
                        TotalAmount: find.TotalAmount,
                        dataCode: find.DataCode,
                        family: find.Family,
                        groupName: v.mainTable.Name,
                        DesImage: i.DesImage ? i.DesImage : "",
                      });
                    });
                  }
                  this.allPrice += find.TotalAmount;
                  this.allCoupon += find.CashAmount;
                  this.useCoupon += Number(find.CouponAmount.toFixed(1));
                  // this.remainderCoupon -= Number(find.CouponAmount.toFixed(1));
                  this.remainderCoupon = this.amend(
                    this.remainderCoupon,
                    Number(find.CouponAmount.toFixed(1)),
                    "-"
                  );
                }
              } else {
                //无
                data = {
                  Coupon: 0,
                  apply: 0,
                  ID: i.ID,
                  ischeck: false,
                  couponRate: i.CouponRate,
                  dataCode: i.DataCode,
                  name: i.LineName,
                  price: i.Price,
                  family: [],
                  otherData: {
                    ...i,
                    groupName: v.mainTable.Name,
                  },
                };
                this.moneyData[v.mainTable.Name][i.ID] = data;
                this.numLimit[v.mainTable.Name] = {
                  MaxLimit: Number(v.mainTable.MaxLimit),
                  MinLimit: Number(v.mainTable.MinLimit),
                  Sex: v.mainTable.Sex,
                };
              }
            } else {
              //未报名无数据时
              data = {
                Coupon: 0,
                ID: i.ID,
                apply: 0,
                ischeck: false,
                couponRate: i.CouponRate,
                dataCode: i.DataCode,
                name: i.LineName,
                price: i.Price,
                family: [],
                otherData: {
                  ...i,
                  groupName: v.mainTable.Name,
                },
              };
              this.moneyData[v.mainTable.Name][i.ID] = data;
              this.numLimit[v.mainTable.Name] = {
                MaxLimit: Number(v.mainTable.MaxLimit),
                MinLimit: Number(v.mainTable.MinLimit),
                Sex: v.mainTable.Sex,
              };
            }
            if (v.mainTable.Sex == "男") {
              this.man = i.SignUpCount;
            }
            if (v.mainTable.Sex == "女") {
              this.woman = i.SignUpCount;
            }
          });
        });
        this.calculate();
        this.$forceUpdate();
        this.loading = false;
      });
    },
    // 金额
    MobileIndexGetUserCardValue(activityId) {
      this.loading = true;
      let parmas = {
        activityId: activityId,
      };
      indexService.MobileIndexGetUserCardValue(parmas).then((data) => {
        this.Coupon = data.data;
        this.remainderCoupon = data.data.Money;
        this.loading = false;
      });
    },
    GetSignUpInfo(activityId) {
      this.loading = true;
      let prams = {
        activityId: activityId,
      };
      indexService.GetSignUpInfo(prams).then((data) => {
        if (data.data.length == 0) {
          this.isApply = false;
          this.isChange = false;
        } else {
          this.isApply = true;
          if (this.setting) {
            this.isChange = true;
          }
          this.signUpInfo = data.data;
          if (data.receiverInfo) {
            this.shippingAddress = {
              tel: data.receiverInfo.Mobile,
              name: data.receiverInfo.ReceiverName,
              address: data.receiverInfo.Address,
            };
          }
        }
        if (this.title == "健身课程") {
          this.initData(dayjs(this.signUpData.StartTime).format("YYYY-MM-DD"));
          this.GetActivityDetail(
            this.signUpData.ID,
            dayjs(this.signUpData.StartTime).format("YYYY-MM-DD")
          );
          return;
        } else {
          this.GetActivityDetail(this.signUpData.ID);
        }
        this.loading = false;
      });
    },
    // 日历初始化数据
    initData(data) {
      this.GetActivityDetail(
        this.signUpData.ID,
        dayjs(data).format("YYYY-MM-DD")
      );
    },

    addNumEvent:function(unit,obj){ 
      if (unit.price) {
        let Cosh = unit.price * unit.couponRate * 0.01 * unit.apply;
        if (Cosh >= 300) {
          Cosh = 300;
        }
        var max = 300 - (obj.coupon-unit.Coupon);
        let Setp =
          this.remainderCoupon && this.remainderCoupon <= 9 ? 0 : 10;
        unit.Coupon =
          Setp > Cosh
            ? 0
            : Cosh > this.remainderCoupon+unit.Coupon
            ? this.remainderCoupon+unit.Coupon
            : Cosh;
            
          if(unit.Coupon>max) unit.Coupon = max;
          this.$set(unit, "Coupon", this.formatAmount(unit.Coupon));
      } else {
        unit.Coupon = 0;
      }
    },
    checkSign(val, unit,obj) {
      unit.ischeck = val;
      if (val) {
        //选中
        if (this.signUpInfo.length != 0) {
          //已报名
          var find = this.signUpInfo.find(
            (item) => item.DataCode == unit.dataCode
          );
          if (find) {
            //有相关数据
            unit.apply = this.mainData.FamilyObject == "on"?unit.family.length:unit.apply;
            unit.Coupon = find.CouponAmount;
            this.checkList.forEach((v) => {
              if (v == unit.dataCode) {
                this.updataList.push(v + "|" + unit.apply);
              }
            });
          } else {
            //无
            if (
              !(
                this.mainData.FamilyObject == "on" &&
                this.title == "旅游出行" &&
                !this.unitname.uInfo.Job
              )
            ) {
              unit.apply = 1;
              if (unit.price) {
                let Cosh = unit.price * unit.couponRate * 0.01;
                if (Cosh >= 300) {
                  Cosh = 300;
                }
                var max = 300 - (obj.coupon-unit.Coupon);
                let Setp =
                  this.remainderCoupon && this.remainderCoupon <= 9 ? 0 : 10;
                unit.Coupon =
                  Setp > Cosh
                    ? 0
                    : Cosh > this.remainderCoupon
                    ? this.remainderCoupon
                    : Cosh;
                if(unit.Coupon>max) unit.Coupon = max;
                this.$set(unit, "Coupon", this.formatAmount(unit.Coupon));
              } else {
                unit.Coupon = 0;
              }
            }
            this.checkList.forEach((v) => {
              if (v == unit.dataCode) {
                this.updataList.push(v + "|" + unit.apply);
              }
            });
          }
        } else {
          //选中人员才显示 代金券金额
          if (
            !(
              this.mainData.FamilyObject == "on" &&
              this.title == "旅游出行" &&
              !this.unitname.uInfo.Job
            )
          ) {
            unit.apply = 1;
            if (unit.price) {
              let Cosh = unit.price * unit.couponRate * 0.01;
              if (Cosh >= 300) {
                Cosh = 300;
              }
              var max = 300 - (obj.coupon-unit.Coupon);
              let Setp =
                this.remainderCoupon && this.remainderCoupon <= 9 ? 0 : 10;
              unit.Coupon =
                Setp > Cosh
                  ? 0
                  : Cosh > this.remainderCoupon
                  ? this.remainderCoupon
                  : Cosh;
                  
                if(unit.Coupon>max) unit.Coupon = max;
                this.$set(unit, "Coupon", this.formatAmount(unit.Coupon));
            } else {
              unit.Coupon = 0;
            }
          }
          this.checkList.forEach((v) => {
            if (v == unit.dataCode) {
              this.updataList.push(v + "|" + unit.apply);
            }
          });
        }
      } else {
        //取消
        unit.apply = 0;
        unit.Coupon = 0;
        this.updataList.forEach((v) => {
          let index = this.fuzzyQuery(this.updataList, unit.dataCode);
          if (index != -1) {
            this.updataList.splice(index, 1);
          }
        });
        unit.family = [];
        this.calculate();
      }

      // if (!(this.mainData.FamilyObject == "on" && this.title == "旅游出行" && !this.unitname.uInfo.Job)) {
      this.calculate();
      // }
    },
    // 获取过滤字符 对象
    fuzzyQuery(list, keyWord) {
      var arr = 0;
      for (var i = 0; i < list.length; i++) {
        if (list[i].indexOf(keyWord) >= 0) {
          arr = i;
        }
      }
      return arr;
    },
    checkMax(val,key,obj) {
      let max = 0;
      if (val.price) {
        var num = this.mainData.FamilyObject == "on">0?val.family.length:val.apply;
        let Cosh = val.price * val.couponRate * 0.01 * num;
        max = Cosh > this.Coupon.Money-obj.coupon+val.Coupon  ? this.Coupon.Money-obj.coupon+val.Coupon : Cosh;
        if(300 - obj.coupon+val.Coupon<max) max = 300 - obj.coupon+val.Coupon;
      } else {
        max = 1;
      }
      if (max > 300) max = 300; 
      return max;
    },
    calculate() {
      // 计算
      this.applyArray = [];
      this.allPrice = 0;
      this.allCoupon = 0;
      this.allNum = 0;
      this.useCoupon = 0;
      this.useMoney = 0;
      this.remainderCoupon = this.Coupon.Money;
      var moneyData = this.moneyData;
      Object.keys(moneyData).forEach((v) => {
        let obj = moneyData[v];
        var allPrice = 0;
        var cash = 0;
        var coupon = 0;
        this.priceData[v] = {};
        Object.keys(obj).forEach((e) => {
          let item = obj[e];
          var TotalAmount = 0,
            CashAmount = 0;
          if (this.mainData.FamilyObject == "on" && this.title == "旅游出行") {
            let length = this.unitname.uInfo.Job
              ? item.apply
              : item.family.length;
            TotalAmount = Number((item.price * length).toFixed(1));
            CashAmount = Number((item.price * length - item.Coupon).toFixed(1));
          } else {
            TotalAmount = Number((item.price * item.apply).toFixed(1));
            CashAmount = Number(
              (item.price * item.apply - item.Coupon).toFixed(1)
            );
          } 
          item.TotalAmount = TotalAmount;
          item.CashAmount = CashAmount;

          if (item.ischeck == true) {
            allPrice += Number(TotalAmount.toFixed(1)); // 该组的总价格.
            cash += Number(CashAmount.toFixed(1)); // 该组的总现金
            coupon += Number(item.Coupon.toFixed(1)); // 该checkbox用的代金券
            var familyObj = [];
            for (var i = 0; i < item.family.length; i++) {
              var find = this.family.find(
                (val) => val.CardNumber == item.family[i]
              );
              if (find) {
                familyObj.push({
                  CardNumber: find.CardNumber,
                  Name: find.Name,
                });
              }
            }
            this.applyArray.push({
              ActivityId: item.otherData.ActivityId,
              ActivityName: this.mainData.ActivityName,
              CashAmount: CashAmount,
              CouponAmount: item.Coupon,
              LineName: item.otherData.LineName,
              PartnerList: this.partner ? this.partner : [],
              SignCount:
                this.mainData.FamilyObject == "on" &&
                this.title == "旅游出行" &&
                !this.unitname.uInfo.Job
                  ? item.family.length
                  : item.apply,
              TotalAmount: TotalAmount,
              dataCode: item.dataCode,
              family: JSON.stringify(familyObj),
              groupName: item.otherData.groupName,
              DesImage: item.otherData.DesImage ? item.otherData.DesImage : "",
            });
            this.allPrice += TotalAmount;
            this.useCoupon += Number(item.Coupon.toFixed(1));

            if (this.useCoupon >= 300) {
              this.useCoupon = 300;
            }

            // this.remainderCoupon -= Number(item.Coupon.toFixed(1));
            this.remainderCoupon = this.amend(
              this.remainderCoupon,
              Number(item.Coupon.toFixed(1)),
              "-"
            );
            this.allCoupon += CashAmount;
            this.allNum += item.apply;
            this.useMoney = parseFloat((this.allPrice - this.useCoupon).toFixed(1));
          }
          this.priceData[v][e] = {
            price: TotalAmount,
            cash: CashAmount,
          };
        });
        this.priceData[v].allPrice = allPrice;
        this.priceData[v].cash = cash;
        this.priceData[v].coupon = coupon;
      });
    },
    formatAmount(couponAmount){
      return parseInt(couponAmount/10)*10
    },
    //num1 num2传入两个值  symbol +-*/符号
    amend(num1, num2, symbol) {
      var str1 = num1.toString(),
        str2 = num2.toString(),
        result,
        str1Length,
        str2Length;
      //解决整数没有小数点方法
      try {
        str1Length = str1.split(".")[1].length;
      } catch (error) {
        str1Length = 0;
      }
      try {
        str2Length = str2.split(".")[1].length;
      } catch (error) {
        str2Length = 0;
      }
      var step = Math.pow(10, Math.max(str1Length, str2Length));
      //
      console.log(step);
      switch (symbol) {
        case "+":
          result = (num1 * step + num2 * step) / step;
          break;
        case "-":
          result = (num1 * step - num2 * step) / step;
          break;
        case "*":
          result = (num1 * step * (num2 * step)) / step / step;
          break;
        case "/":
          result = (num1 * step) / (num2 * step);
          break;
        default:
          break;
      }
      return result;
    },
    handleChange(value, unit,obj) {
      this.$set(unit, "apply", value);
      this.addNumEvent(unit,obj)
      this.calculate();
      this.$forceUpdate();
    },
    handleChangeDai(value, unit) {
      this.$set(unit, "Coupon", value);
      this.calculate();
      this.$forceUpdate();
    },
    checkRenSign(value, obj, unit) {
      if (value ||unit.family.length>0) {
        this.$set(unit, "apply", unit.family.length);
        if (unit.price) {
          let Cosh = unit.price * unit.apply * unit.couponRate * 0.01;
          let Setp = this.remainderCoupon && this.remainderCoupon <= 9 ? 1 : 10;
          let Coupon =
            Setp > Cosh
              ? 0
              : Cosh > this.remainderCoupon
              ? this.Coupon.Money
              : Cosh;
              
          var max = 300 - (obj.coupon-unit.Coupon);
          if(Coupon>max) Coupon = max;

          this.$set(unit, "Coupon", this.formatAmount(Coupon));
        } else {
          this.$set(unit, "Coupon", 0);
        }
        this.checkList.forEach((v) => {
          if (v == unit.dataCode) {
            this.updataList.push(v + "|" + unit.apply);
          }
        });
      } else {
        this.$set(unit, "apply", 0);
        this.$set(unit, "Coupon", 0);
        this.updataList.forEach((v) => {
          let index = this.fuzzyQuery(this.updataList, unit.dataCode);
          if (index != -1) {
            this.updataList.splice(index, 1);
          }
        });
      }
      this.calculate();
      this.$forceUpdate();
    },
    // 提交报名
    submitHandle(item, index) {
      /**
       * this.mainData.MaxLimit  最多可选项利用el-checkbox-group最大值判断
       * this.mainData.MinLimit  必须选择项，少于无法提交
       * mainTable[index].MinLimit 最少可选项,少于无法提交
       * mainTable[index].MaxLimit 最多可选项利用el-checkbox-group最大值判断
       * detailTable[index].
       */

      if (
        this.mainData.MinLimit > this.updataList.length ||
        this.mainData.MinLimit > this.updataList.length
      ) {
        this.$message.error("至少报名" + this.mainData.MinLimit + "项");
        return;
      }

      for (var key in this.applyArray) {
        if (this.mainData.FamilyObject == "on" && this.title == "旅游出行") {
          let length = this.unitname.uInfo.Job
            ? item.SignCount
            : JSON.parse(this.applyArray[key].family).length;
          if (length == 0) {
            this.$message.warning(
              "请选择参与" +
                this.applyArray[key].groupName +
                this.applyArray[key].LineName +
                "的人员"
            );
            return;
          }
        }
      }

      let parmas = {
        dataCode: this.updataList,
        isChange: this.isChange,
      };
      indexService.GetSubstituteCount(parmas).then((res) => {
        var { data } = res;
        if (data.allCount == 0) {
          this.$confirm("是否确认参加此次活动?", "提醒", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "success",
          })
            .then(() => {
              ok();
            })
            .catch(() => {});
        } else {
          var { list } = data;
          var str = "";
          for (var j = 0; j < list.length; j++) {
            if (list[j].count != 0) {
              str += `目前${
                list[j].name
              }存在候补人数<span style="color: #65BDFE">${
                list[j].count - 1 < 0 ? 0 : list[j].count - 1
              }</span><br>`;
            }
          }
          str += `是否确认加入候补队列？`;
          this.$confirm(str, "提醒", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            dangerouslyUseHTMLString: true,
            type: "success",
          })
            .then(() => {
              ok(true);
            })
            .catch(() => {});
        }
      });
      var ok = (houbu) => {
        let action = "";
        if (this.isChange) {
          action =
            "/MobileApis/ActivityHandler.ashx?action=SignUpModify";
        } else {
          action = "/MobileApis/ActivityHandler.ashx?action=SignUp";
        }
        let dataArrary = JSON.parse(JSON.stringify(this.applyArray));
        dataArrary.map((e) => {
          delete e.DesImage;
        });
        let parmas = {
          activityId: this.mainData.ID,
          data: dataArrary,
        };
        if (this.title == "专项礼品") {
          var data = JSON.parse(JSON.stringify(parmas.data));
          for (var i = 0; i < data.length; i++) {
            data[i].BpAmount = data[i].CashAmount;
            delete data[i].CashAmount;
          }
          parmas.data = data;
          parmas.receiverInfo = {
            ReceiverName: this.shippingAddress.name,
            Address: this.shippingAddress.address,
            Mobile: this.shippingAddress.tel,
          };
        }
        if (this.title == "旅游出行") {
          parmas.partnerList = this.partner ? [this.partner] : [];
          parmas.peopleInfo = this.step2PeopleInfo;
        }
        indexService.getActiveDataList(action, parmas).then((data) => {
          var strTitle = `${
            this.isChange ? "修改" : houbu ? "候补" : "报名"
          }成功`;

          var str = `你已经成功${this.isChange ? "修改" : ""}${
            houbu ? "候补" : "报名"
          }:${this.mainData.ActivityName}`;

          if (this.title == "专项礼品") {
            strTitle = `提醒`;
            str = `预订成功<br>正在备货中，请耐心等待`;
          }

          try {
            if (data.data && Array.isArray(data.data)) {
              for (let i = 0; i < data.data.length; i++) {
                str += `<br>${data.data[i]}`;
              }
            }
          } catch (err) {}
          this.$alert(str, strTitle, {
            dangerouslyUseHTMLString: true,
            callback: (action) => {
              this.$emit("submit");
              if (this.title == "专项礼品") {
                this.active = 1;
              }
              this.dialogClose();
            },
          });
        });
      };
    },
    partnerChange(item, obj) {
      if (!item) {
        this.partnerText = ``;
        this.partner = null;
        return;
      }
      obj.forEach((v) => {
        if (v.Code == item) {
          this.partnerText = v.Name;
          this.partner = v;
        }
      });
    },
    // 取消预约 取消候补
    cancleHandle(item, index) {
      this.$confirm("是否确认不参加此次活动？", "提醒", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      })
        .then(() => {
          let parmas = {
            dataCode: item.DataCode,
          };
          indexService.CancelSignUpCourse(parmas).then((data) => {
            this.$message.success("取消报名成功！");
            this.GetActivityDetail(
              this.signUpData.ID,
              dayjs(item.StartTime).format("YYYY-MM-DD")
            );
          });
        })
        .catch(() => {});
    },
    reservationHandle(item, index){
      let parmas = {
        dataCode: [`${item.DataCode}|1`],
        isChange: this.isChange,
      };
      indexService.GetSubstituteCount(parmas).then((res) => {
        var { data } = res;
        if (data.allCount == 0) {
          this.$confirm("是否确认参加此次活动?", "提醒", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "success",
          })
            .then(() => {
              ok();
            })
            .catch(() => {});
        } else {
          var { list } = data;
          var str = "";
          for (var j = 0; j < list.length; j++) {
            if (list[j].count != 0) {
              str += `目前${
                list[j].name
              }存在候补人数<span style="color: #65BDFE">${
                list[j].count - 1 < 0 ? 0 : list[j].count - 1
              }</span><br>`;
            }
          }
          str += `是否确认加入候补队列？`;
          this.$confirm(str, "提醒", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            dangerouslyUseHTMLString: true,
            type: "success",
          })
            .then(() => {
              ok(true);
            })
            .catch(() => {});
        }
      });
      var ok = (houbu) => {
        let parmas = {
          dataCode: item.DataCode,
          name: item.LineName,
          activityId: this.mainData.ID,
          tempSign: this.mainData.tempSign,
        };
        indexService.SignUpDetail(parmas).then((data) => {
          var strTitle = `${
            this.isChange ? "修改" : houbu ? "候补" : "报名"
          }成功`;

          var str = `你已经成功${this.isChange ? "修改" : ""}${
            houbu ? "候补" : "报名"
          }:${this.mainData.ActivityName}`;

          if (this.title == "专项礼品") {
            strTitle = `提醒`;
            str = `预订成功<br>正在备货中，请耐心等待`;
          }

          try {
            if (data.data && Array.isArray(data.data)) {
              for (let i = 0; i < data.data.length; i++) {
                str += `<br>${data.data[i]}`;
              }
            }
          } catch (err) {}
          this.$alert(str, strTitle, {
            dangerouslyUseHTMLString: true,
            callback: (action) => {
              this.$emit("submit");
              if (this.title == "专项礼品") {
                this.active = 1;
              }
              this.dialogClose();
            },
          });
        });
      };
    },
    // 专项礼品
    nextStep() {
      if (this.active == 0) {
        if (
          this.mainData.MinLimit > this.updataList.length ||
          this.mainData.MinLimit > this.updataList.length
        ) {
          this.$message.error("至少报名" + this.mainData.MinLimit + "项");
          return;
        }
        if (this.title == "旅游出行") {
          this.step2PeopleInfoEvent();
          this.getSignList();
        }
        this.active = 1;
      } else {
        if (
          this.title == "专项礼品" &&
          Object.keys(this.shippingAddress).length === 0
        ) {
          this.$message.error("未选择收货地址");
          return;
        }
        if (this.title == "旅游出行") {
          let flag = null;
          for (var i = 0; i < this.step2PeopleInfo.length; i++) {
            this.$refs["step2PeopleInfo"][i].validate((valid) => {
              if (valid) {
                flag = false;
              } else {
                flag = true;
              }
            });
            if (flag) return;
          }
        }
        this.submitHandle();
      }
    },
    // 上一步
    prevStep() {
      if (this.active == 1) this.active = 0;
    },
    getSignList() {
      let param = {
        activityId: this.signUpData.ID,
      };
      indexService.GetSignUpList(param).then((data) => {
        this.partnerOption = data.data;
      });
    },
    step2PeopleInfoEvent() {
      this.step1Data = this.applyArray;
      let changePeopleData = this.peopleInfo;
      var array = [];
      for (let i = 0; i < this.step1Data.length; i++) {
        var filter = changePeopleData.filter(
          (item) => item.DataCode == this.step1Data[i].dataCode
        );

        for (let j = 0; j < this.step1Data[i].SignCount; j++) {
          var json = {
            Name: j == 0 ? this.unitname.uInfo.Name : "",
            Mobile: j == 0 ? this.unitname.uInfo.Mobile : "",
            CardNumber: j == 0 ? this.unitname.uInfo.IdCard : "",
            showName: `${this.step1Data[i].groupName}（${
              this.step1Data[i].LineName
            }）-人员${j + 1}`,
            DataCode: this.step1Data[i].dataCode,
          };

          if (filter) {
            if (filter[j]) {
              json.Name = filter[j].Name;
              json.Mobile = filter[j].Mobile;
              json.CardNumber = filter[j].CardNumber;
            }
          }

          array.push(json);
        }
      }
      this.step2PeopleInfo = array;
      this.$message.warning("预选择搭档建议选择同性，并先征得对方同意");
    },
    // 弹出地址框
    showAddress(item) {
      this.addressShow = true;
      this.address = item;
    },
    setAddress(data) {
      if (this.isApply) {
        this.$confirm("是否更换此地址为收货地址？", "更换地址", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.loading = true;
            let param = {
              ReceiverName: data.name,
              Address: data.address,
              Mobile: data.tel,
              ActivityId: this.signUpData.ID,
            };
            indexService
              .ModifyReceiverInfo(param)
              .then(() => {
                this.$message.success("修改成功！");
                this.$emit("submit");
                this.loading = false;
                this.dialogClose();
              })
              .catch((e) => {
                this.loading = false;
              });
          })
          .catch(() => {});
      } else {
        this.shippingAddress = data;
      }
    },
    // 取消预定
    cancelReserve() {
      this.$confirm(
        this.title == "专项礼品"
          ? "是否确认取消预订？"
          : "是否确认不参加此次活动？",
        "提醒",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.loading = true;
          let param = {
            activityId: this.signUpData.ID,
          };
          indexService
            .CancelSignUp(param)
            .then(() => {
              this.$alert(
                `你已经取消${this.title == "专项礼品" ? "预订" : "报名"}了${
                  this.mainData.ActivityName
                }`,
                this.title == "专项礼品" ? "取消预订成功" : "取消报名成功",
                {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    this.$emit("submit");
                    this.active = 0;
                    this.dialogClose();
                  },
                }
              );
              this.loading = false;
            })
            .catch((e) => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    dialogClose() {
      this.dialogVisible = false;
      this.isApply = false;
      this.groupData = [];
      this.mainData = {};
      this.updataList = [];
      this.moneyData = {};
      this.checkList = [];
      this.signUpInfo = [];
      this.shippingAddress = {};
      this.applyArray = [];
      this.allNum = 0;
      this.title = "";
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding: 5px 20px 10px 20px;

  &::-webkit-scrollbar {
    // 是否显示
    display: none;
    width: 6px;
    padding-right: 4px;
    background-color: #fff;
  }

  &::-webkit-scrollbar-thumb {
    -webkit-border-radius: 3px;
    border-radius: 3px;
    background-color: #c6c6c6;
  }
}

.question_panel {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  margin-bottom: 15px;
  border-top: 0;

  .question_panel_body {
    padding-top: 0;
  }
}

.card_question_bottom {
  margin-top: 13px;
  line-height: 12px;

  .time {
    font-size: 13px;
    color: #999;
  }

  .button {
    padding: 0;
    float: right;
    color: #999;
  }
}

.card_question_info {
  font-size: 12px;
  color: #666;
  line-height: 26px;
}

.mt-20 {
  margin-top: 20px;
}

.sign_checkbox,
.sign_checkbox /deep/ .el-checkbox__label {
  display: flex;
  align-items: center;
}

.sign_checkbox /deep/ .el-descriptions__header {
  margin-bottom: 10px;
}

.sign_checkbox
  /deep/
  .el-descriptions
  :not(.is-bordered)
  .el-descriptions-item__cell {
  padding-bottom: 2px;
}

.sign_address {
  display: flex;
  align-items: center;
}

.sign_address i {
  font-size: 22px;
  color: #7a7a7a;
}

.sign_address div {
  flex: 1;
  margin: 0 10px;
}

.el-row.sign_row {
  display: flex;
  flex-wrap: wrap;
}

.el-row.sign_row .el-col-12 {
  border-bottom: 1px dashed rgb(238, 238, 238);
  padding: 5px 0;
}

.el-row.signup_row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
  background: #f7faff;

  .signup_icon {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: linear-gradient(-25deg, #45afff 0%, #7ac6fc 100%);
    margin: 0 auto;

    img {
      margin: 5px;
    }
  }

  /deep/ .el-descriptions {
    font-size: 12px;
    padding: 5px 0;

    .el-descriptions__body {
      background: #f7faff;
    }
  }

  /deep/ .el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
    padding: 5px;
  }
}
</style>
